<template>
  <div
    class="menu additional-field__input-menu pa-4 flex flex-wrap flex-direction-column align-start"
    :data-qa="`table-row-${index}-additional_field-${field.id}-menu`">
    <sForm
      ref="inputAdditionalFieldForm"
      label-position="top"
      :model="input_field"
      :rules="rules">
      <AdditionalFieldInput
        :field.sync="input_field"
        validation-prop="value"/>
    </sForm>
    <RadioGroup
      class="mb-16"
      data-qa="all-mode"
      :header="$t(`Tenders.ApplyAllItems`)"
      label_class="h7-text"
      :model.sync="all_mode"
      row/>
    <sButton
      @click="apply">
      {{ $t(`Common.Apply`) }}
    </sButton>
  </div>
</template>
<script>
import { additionalFieldsMixin } from 'mixins'
import RadioGroup from 'components/common/inputs/RadioGroup.vue'
import AdditionalFieldInput from 'components/additional fields/AdditionalFieldInput.vue'

export default {
  name: 'additionalFieldTdMenu',
  mixins: [ additionalFieldsMixin ],
  data() {
    const that = this
    return {
      input_field: {},
      all_mode: false,
      rules: {
        value: that.$_getValidationByType(
          that.field?.typeId || that.field?.type?.typeId,
          that.field.settingValues.some(set => set.settingType == 'REQUIRED' && eval(set.value)
          ))
      }
    }
  },
  methods: {
    apply() {
      this.$refs.inputAdditionalFieldForm.validate(async (valid) => {
        if (!valid) {
          return
        }
        if (this.all_mode) {
          const allPosition = this.$_.cloneDeep(this.positions)
          allPosition.forEach(position => {
            position.additional_fields[this.input_field.id ].value = this.input_field.value
          })
          this.$emit('update:positions', allPosition)
        } else {
          this.field_sync = this.input_field
        }

        this.$emit('change')
      })
    }
  },
  computed: {
    field_sync: {
      get() {
        return this.field
      },
      set(val) {
        this.$emit('update:field',  val)
      }
    }
  },
  created() {
    this.input_field = this.$_.cloneDeep(this.field)
  },
  watch: {
    active() {
      this.input_field = this.$_.cloneDeep(this.field)
    }
  },
  props: {
    field: {
      type: Object,
      required: true
    },
    positions: {
      type: Array,
      default: () => []
    },
    active: {
      type: Boolean,
    },
    index: {
      type: Number
    },
  },
  components: {
    RadioGroup,
    AdditionalFieldInput
  }
}
</script>
<style lang="scss" scoped>
.additional-field__input-menu {
  min-width: 342px;
}
</style>
